import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner"; // Import loader
import { StandardURL } from "../App";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    setIsLoading(true); // Set loading state to true
    e.preventDefault();
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/auth/forgot-pwd`,
        { email }
      );
      // Display success message
      toast.success(response.data.response);
      setIsLoading(false); // Set loading state to false

      // Redirect to the login page
      navigate("/");
    } catch (error) {
      setIsLoading(false); // Set loading state to false
      toast.error(error.response?.data?.response || "An error occurred, please try again later.");
      console.error(error); // Display error message
    }
  };

  return (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-cyan-100 py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 transform hover:scale-105 transition-all duration-300 ease-in-out">
      <div className="text-center">
        <h2 className="mt-2 text-4xl font-extrabold text-gray-900 leading-tight">
          Forgot Your Password? 🔒
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          No worries! Enter your email below to receive a password reset link.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="mt-8 space-y-6">
        <div className="space-y-4">
          <div>
            <label htmlFor="email" className="sr-only">
              Email address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 sm:text-base transition duration-200 ease-in-out"
              placeholder="Enter your email address"
              value={email}
              onChange={handleChange}
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            disabled={isLoading}
            className={`
              relative w-full flex justify-center py-2.5 px-4 border border-transparent text-lg font-semibold rounded-lg shadow-md
              ${isLoading
                ? "bg-teal-400 cursor-not-allowed"
                : "bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transform transition-all duration-200 ease-in-out hover:scale-105"
              }
              text-white
            `}
          >
            {isLoading ? (
              <Oval
                height={24}
                width={24}
                color="white"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="rgba(255,255,255,0.4)"
                strokeWidth={5}
                strokeWidthSecondary={5}
              />
            ) : (
              "Send Reset Link"
            )}
          </button>
        </div>
        <div className="text-sm text-center mt-6 text-gray-600">
          <a
            href="/"
            className="font-semibold text-teal-600 hover:text-teal-500 transition-colors duration-200"
          >
            Remembered your password? Log In
          </a>
        </div>
      </form>
    </div>
  </div>
);
};

export default ForgotPassword;